import { useState } from 'react';
import Navbar from '../../components/Navbar';
import useStrategyData from '../../hooks/useStrategyData';
import StrategyCard from '../../components/StrategyCard';
import StrategyModal from '../../components/StrategyModal';
import SummaryBar from '../../components/SummaryBar/index.jsx';

const ACCOUNT_IDS = ['1','IB','JO','sub1','sub2','sub3','sub4','sub5','sub6','sub7','sub8','sub9','sub10'];

const MainPage = () => {
  const [selectedStrategy, setSelectedStrategy] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const { filteredStrategies, logoMap, loading } = useStrategyData(ACCOUNT_IDS, true);

  const liveStrategies = filteredStrategies.filter(s => !s.strategy_type);
  const demoStrategies = filteredStrategies.filter(s => s.strategy_type === 'DEMO');
  const visibleStrategies = [...liveStrategies, ...demoStrategies];

  return (
    <>
      <Navbar />

      {loading ? (
        <div className="container">⏳ Ładowanie strategii...</div>
      ) : visibleStrategies.length === 0 ? (
        <div className="container">⚠️ Nie masz żadnych strategii!</div>
      ) : (
        <>
          <SummaryBar
            deposit={visibleStrategies.reduce((sum, s) => sum + parseFloat(s.deposit || 0), 0)}
            invested={visibleStrategies.reduce((sum, s) => sum + parseFloat(s.usd_in_trade || 0), 0)}
            profit={visibleStrategies.reduce((sum, s) => sum + parseFloat(s.withdrawable_profit || 0), 0)}
            roi={
              visibleStrategies.length
                ? visibleStrategies.reduce((sum, s) => sum + parseFloat(s.annual_roi || 0), 0) / visibleStrategies.length
                : 0
            }
          />

          <div className="container cards-wrap">
            {visibleStrategies.map(strategy => {
              const baseSymbol = (strategy.symbol?.includes('/')
                ? strategy.symbol.split('/')[0]
                : strategy.symbol || ''
              ).toLowerCase();
              const logoUrl = logoMap[baseSymbol] || '';

              return (
                <StrategyCard
                  key={`${strategy.strategyId}-${strategy.accountId || ''}`}
                  strategy={strategy}
                  logoUrl={logoUrl}
                  onClick={() => {
                    setSelectedStrategy({ ...strategy, _logoUrl: logoUrl });
                    setShowModal(true);
                  }}
                />
              );
            })}
          </div>

          {showModal && selectedStrategy && (
            <StrategyModal
              strategy={selectedStrategy}
              logoUrl={
                logoMap[(selectedStrategy.symbol?.split('/')[0] || '').toLowerCase()]
              }
              onClose={() => setShowModal(false)}
            />
          )}
        </>
      )}
    </>
  );
};

export default MainPage;
